import { data } from 'autoprefixer'
import axios from 'axios'

// 请求拦截
// 接入waf前端发送到接入BOT管理的请求，需要配置withcredentials=true
// 这个参数通常前端框架中默认为false，会禁止js跨域访问cookie，导致BOT管理的框架无法对请求插入校验信息
// 详细解释参考文档 https://liangyihui.feishu.cn/wiki/EhfDwWO0eiHUnsk5RJNcaGomnff?chunked=false 
axios.interceptors.request.use(
  function (config) {
    config.withcredentials = false
    if(config.url.indexOf(window.Global_apiserver) === 0 || config.url.indexOf(window.Global_function_serve) === 0){
      config.withcredentials = true
    }
    return config
  },
  function (error) {
    console.log(error)
    return false
  }
)

// 响应拦截
axios.interceptors.response.use(
  function (response) {
    // vue-resource 统一替换 axios 兼容vue-resource与axios返回体不一致，添加body, bodyText, url, ok字段
    response.body = response.data
    response.bodyText = JSON.stringify(response.data)
    response.url = response.config.url
    response.ok = false
    if(response.status >= 200 && response.status < 300){
      response.ok = true
    }
    return response
  },
  function (error) {
    return false
  }
)

export { axios }
